// tslint:disable
import * as React from 'react'
import './search-icon.css'

export const SearchIcon = (props: any) => (
  <svg
    id="magnifying-glass_1_"
    className="search-icon"
    data-name="magnifying-glass (1)"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '15.094'}
    height={props.height || '15.094'}
    viewBox="0 0 15.094 15.094"
  >
    <path
      id="Path_2665"
      data-name="Path 2665"
      d="M25.909,25.022l-3.629-3.629a6.356,6.356,0,1,0-.89.89l3.629,3.626a.628.628,0,0,0,.89-.887Zm-8.548-2.566a5.1,5.1,0,1,1,5.1-5.1A5.1,5.1,0,0,1,17.361,22.456Z"
      transform="translate(-11 -11)"
    />
  </svg>
)
